<template>
  <div>

    <v-card-title>
      <div>
        <p class="v-das-title-font font-weight-bold mt-0 mb-0 v-das-title-font">ตั้งค่า List of Academic Services and Working Hours </p>
      </div>
    </v-card-title>

    <v-card-text>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="ค้นหา"
        single-line
        hide-details
        outlined
        dense
        class="mb-4"
      ></v-text-field>

      <v-data-table :headers="headers" :items="items" :search="search" item-key="id" class="elevation-1 custom-header-table"
        hide-default-footer :items-per-page="-1">
        <!-- No. -->
        <template v-slot:item.no="{ item }">
          <div class="text-center">{{ item.no }}</div>
        </template>

        <!-- Points -->
        <template v-slot:item.points="{ item }">
          <div class="text-right">
            <!-- {{ item }} xxxx -->
            {{ item.point }}
          </div>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip small dark :color="item.status === 'on' ? 'green' : 'red'">
            {{ item.status === 'on' ? 'ON' : 'OFF' }}
          </v-chip>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn class="v-head-font font-weight-bold" small text color="primary" @click="openSheet(item)">
            ตั้งค่า
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Right Sheet -->
    <v-navigation-drawer v-model="sheet" right temporary fixed width="500">

      <v-sheet class="pa-4" elevation="0">
        <div class="d-flex justify-space-between align-center mb-3">
          <strong>รายละเอียด</strong>
          <v-btn icon @click="sheet = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider class="mb-3" />

        <div class="pa-3" v-if="Object.keys(selectedItem).length != 0">
          <p><strong>ID REF:</strong> {{ selectedItem.id }}</p>
          <p><strong>ชื่อ:</strong> {{ selectedItem.detail }}</p>
          <p><strong>คะแนน :</strong> {{ parseInt(selectedItem.point).toFixed(2) }}</p>
        </div>

        <!-- Action -->
        <div class="text-right">
          <v-btn v-if="selectedItem.status === 'on'" color="red" dark @click="toggleStatus('off')">
            OFF
          </v-btn>

          <v-btn v-else color="green" dark @click="toggleStatus('on')">
            ON
          </v-btn>
        </div>
      </v-sheet>


    </v-navigation-drawer>

  </div>
</template>

<script>
export default {
  name: 'SubSetting1',
  data() {
    return {
      search: '',
      sheet: false,
      selectedItem: {},
      headers: [
        {
          text: "Activities",
          value: "detail",
          align: "start",
          sortable: false,
          class: "font-weight-bold blue-grey darken-3 white--text",
        },
        {
          text: "Number of working hours",
          value: "points",
          align: "end",
          sortable: false,
          class: "font-weight-bold blue-grey darken-3 white--text",
        },
        {
          text: "สถานะ",
          value: "status",
          align: "center",
          sortable: false,
          class: "font-weight-bold blue-grey darken-3 white--text",
        },
        {
          text: "",
          value: "action",
          align: "center",
          sortable: false,
          class: "font-weight-bold blue-grey darken-3 white--text",
        },
      ],
      items: []
    }
  },
  mounted() {
    this.getActivityType()
  },
  methods: {
    openSheet(item) {
      this.selectedItem = item
      this.sheet = true
    },
    async getActivityType() {
      this.items = [];
      try {
        const resType = await this.$http.get(`/academic-service/activity-types/`);
        if ([200, 201].includes(resType.status)) {
          this.items = resType.data.map((item) => {
            return {
              text: `${item.detail} (x${parseFloat(item.point).toFixed(2)} Point )`,
              value: item.id,
              ...item
            };
          }).sort((a, b) => a.detail.localeCompare(b.detail))
          console.log(this.items)
        } else {
          throw { resType };
        }
      } catch (error) {
        console.log(error)
      }
    },
    async toggleStatus (value) {
      this.selectedItem.status = value
      // /academic-service/activity-types/{id}/
      try {
        const sendChange = new FormData();
        sendChange.append("status", value);
        const resPatch = await this.$http.patch(
          `/academic-service/activity-types/${this.selectedItem.id}/`,
          sendChange,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (resPatch.status === 200) {
          const index = this.items.findIndex(
            i => i.id === this.selectedItem.id
          )
          if (index !== -1) {
            this.$set(this.items, index, { ...this.selectedItem })
          }
        }
        else{
          throw { resPatch }
        }
      } catch (error) {
        console.log(error)
      }

    }
  }
}
</script>

<style scoped>
.custom-header-table thead th {
  background-color: #000 !important;
  color: #fff !important;
  font-weight: bold;
  text-align: center;
}
</style>